import Cookies from 'js-cookie/src/js.cookie';

const maxParticleCount = 50; //set max confetti count
const particleSpeed = 1; //set the particle animation speed
let startConfetti; //call to start confetti animation
let stopConfetti; //call to stop adding confetti

const confetti = () => {
  const colors = [
    'DodgerBlue',
    'OliveDrab',
    'Gold',
    'Pink',
    'SlateBlue',
    'LightBlue',
    'Violet',
    'PaleGreen',
    'SteelBlue',
    'SandyBrown',
    'Chocolate',
    'Crimson',
  ];
  let streamingConfetti = false;
  let animationTimer = null;
  const particles = [];
  let waveAngle = 0;

  function resetParticle(particle, width, height) {
    particle.color = colors[(Math.random() * colors.length) | 0];
    particle.x = Math.random() * width;
    particle.y = Math.random() * height - height;
    particle.diameter = Math.random() * 10 + 5;
    particle.tilt = Math.random() * 10 - 10;
    particle.tiltAngleIncrement = Math.random() * 0.07 + 0.05;
    particle.tiltAngle = 0;
    return particle;
  }

  function startConfettiInner() {
    window.requestAnimFrame = (function () {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
          return window.setTimeout(callback, 16.6666667);
        }
      );
    })();
    const canvasContainer = document.querySelector('[data-confetti-container]');
    const canvas = document.getElementById('confetti-canvas');
    const width = canvasContainer.clientWidth - 32;
    const height = canvasContainer.clientHeight - 24;
    canvas.setAttribute('style', 'display:block;pointer-events:none');
    canvas.width = width;
    canvas.height = height;

    function updateParticles() {
      const width = canvasContainer.clientWidth - 32;
      const height = canvasContainer.clientHeight - 24;
      let particle;
      waveAngle += 0.01;
      for (let i = 0; i < particles.length; i++) {
        particle = particles[i];
        if (!streamingConfetti && particle.y < -15) particle.y = height + 100;
        else {
          particle.tiltAngle += particle.tiltAngleIncrement;
          particle.x += Math.sin(waveAngle);
          particle.y +=
            (Math.cos(waveAngle) + particle.diameter + particleSpeed) * 0.5;
          particle.tilt = Math.sin(particle.tiltAngle) * 15;
        }
        if (
          particle.x > width + 20 ||
          particle.x < -20 ||
          particle.y > height
        ) {
          if (streamingConfetti && particles.length <= maxParticleCount)
            resetParticle(particle, width, height);
          else {
            particles.splice(i, 1);
            i--;
          }
        }
      }
    }

    function drawParticles(context) {
      let particle;
      let x;
      for (let i = 0; i < particles.length; i++) {
        particle = particles[i];
        context.beginPath();
        context.lineWidth = particle.diameter;
        context.strokeStyle = particle.color;
        x = particle.x + particle.tilt;
        context.moveTo(x + particle.diameter / 2, particle.y);
        context.lineTo(x, particle.y + particle.tilt + particle.diameter / 2);
        context.stroke();
      }
    }

    window.addEventListener(
      'resize',
      function () {
        canvas.width = canvasContainer.clientWidth - 32;
        canvas.height = canvasContainer.clientHeight - 24;
      },
      true
    );
    const context = canvas.getContext('2d');
    while (particles.length < maxParticleCount)
      particles.push(resetParticle({}, width, height));
    streamingConfetti = true;
    if (animationTimer === null) {
      (function runAnimation() {
        context.clearRect(0, 0, window.innerWidth, window.innerHeight);
        if (particles.length === 0) animationTimer = null;
        else {
          updateParticles();
          drawParticles(context);
          animationTimer = window.requestAnimFrame(runAnimation);
        }
      })();
    }
  }

  function stopConfettiInner() {
    streamingConfetti = false;
  }

  startConfetti = startConfettiInner;
  stopConfetti = stopConfettiInner;
  const confettichecker = document.querySelector('[data-confetti-container]');

  if (confettichecker) {
    if (Cookies.get('confettiCannonBoom') !== 'true') {
      Cookies.set('confettiCannonBoom', 'true', { expires: 1 });
      startConfetti();
      const confettiClose = document.querySelector('[data-confetti-close]');
      confettiClose.classList.remove('hide');
      confettiClose.addEventListener('click', () => {
        stopConfetti();
        confettiClose.classList.add('hide');
      });
    }
  }
};

export default confetti